import { render, staticRenderFns } from "./batchDownRecord.vue?vue&type=template&id=799135d4&scoped=true"
import script from "./batchDownRecord.vue?vue&type=script&lang=js"
export * from "./batchDownRecord.vue?vue&type=script&lang=js"
import style0 from "./batchDownRecord.vue?vue&type=style&index=0&id=799135d4&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "799135d4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('799135d4')) {
      api.createRecord('799135d4', component.options)
    } else {
      api.reload('799135d4', component.options)
    }
    module.hot.accept("./batchDownRecord.vue?vue&type=template&id=799135d4&scoped=true", function () {
      api.rerender('799135d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/policy/customerManage/correctionRecord/batchDownRecord.vue"
export default component.exports